import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import BlogCards from "../../../components/blog/BlogCards";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPosts,
  selectTopPosts,
  selectPostsLoading,
  selectPostsError,
} from "../../../store/postsSlice";
import { AppDispatch } from "../../../store/store";
import { Link as RouterLink } from "react-router-dom";

const BlogList = () => {
  const dispatch = useDispatch<AppDispatch>();
  const topPosts = useSelector(selectTopPosts(3));
  const loading = useSelector(selectPostsLoading);
  const error = useSelector(selectPostsError);

  useEffect(() => {
    dispatch(fetchPosts());
  }, [dispatch]);

  if (loading) {
    return (
      <Box
        id="blog"
        sx={{
          pb: { md: 10 },
          pt: { xs: 6, md: 10 },
          bgcolor: "white",
          display: 'flex',
          justifyContent: 'center',
          scrollMarginTop: { xs: 0 },
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error || topPosts.length === 0) {
    return null;
  }

  return (
    <Box
      id="blog"
      sx={{
        pb: { md: 10 },
        pt: { xs: 6, md: 10 },
        bgcolor: "white",
        scrollMarginTop: { xs: 0 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="center">
          <Grid
            size={{ xs: 12, md: 8 }}
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <Typography
              variant="h3"
              sx={{
                color: "#1e293b",
                fontWeight: 700,
                mb: 2,
                textAlign: "center",
                fontSize: { xs: "36px", md: "48px" },
                lineHeight: 1.2,
              }}
            >
              Blog
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#414141",
                mb: 2,
                textAlign: "center",
                fontSize: { xs: "18px", md: "20px" },
                lineHeight: 1.6,
              }}
            >
              Explore related articles:
            </Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <BlogCards displayedPosts={topPosts} />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Box sx={{ textAlign: "center" }}>
              <Button
                component={RouterLink}
                to="/blog"
                variant="contained"
                color="primary"
                sx={{
                  bgcolor: "#5C78FF",
                  borderRadius: "30px",
                  px: 4,
                  py: 1.5,
                  fontSize: "16px",
                  fontWeight: 600,
                  textTransform: "none",
                  boxShadow: "0 4px 15px rgba(92, 120, 255, 0.3)",
                  "&:hover": {
                    bgcolor: "#4660c8",
                    boxShadow: "0 6px 20px rgba(92, 120, 255, 0.4)",
                  },
                  "&:disabled": {
                    bgcolor: "#ccc",
                  },
                }}
              >
                View all posts
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default BlogList;
